// Every screen transition the root stack finishes, opening or closing. RootNavigator feeds this
// from its screen listeners; screens that drop heavy content once covered wait on it so they are
// not left blank while the screen replacing them is still animating in.

type Listener = () => void;

const listeners = new Set<Listener>();

export const notifyTransitionEnd = () => {
	listeners.forEach(listener => listener());
};

export const onTransitionEnd = (listener: Listener) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};
